<template>
	<div>我的优惠券</div>
</template>

<script>
	export default {
		name: 'CouponList',
		components: {},
		props: {},
		data() {
			return {}
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
